import { render, staticRenderFns } from "./TTEmojiInput.vue?vue&type=template&id=2b9bcd28&scoped=true"
import script from "./TTEmojiInput.vue?vue&type=script&lang=js"
export * from "./TTEmojiInput.vue?vue&type=script&lang=js"
import style0 from "./TTEmojiInput.vue?vue&type=style&index=0&id=2b9bcd28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9bcd28",
  null
  
)

export default component.exports